import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchRunsArgs, SearchRunsOutput } from "types/generated";

type SearchAccountRunsData = {
  searchRuns: Pick<SearchRunsOutput, "edges" | "total">;
};

type SearchAccountRunsVariables = QuerySearchRunsArgs & {
  includeTotal: boolean;
};

export const SEARCH_ACCOUNT_RUNS: TypedDocumentNode<
  SearchAccountRunsData,
  SearchAccountRunsVariables
> = gql`
  query SearchAccountRuns($input: SearchInput!, $includeTotal: Boolean!, $offset: Int) {
    searchRuns(input: $input, offset: $offset) {
      total @include(if: $includeTotal)
      edges {
        cursor
        node {
          isModule
          run {
            id
            commit {
              authorLogin
              authorName
              hash
              message
              timestamp
              url
            }
            createdAt
            delta {
              addCount
              changeCount
              deleteCount
              resources
              importCount
              forgetCount
              moveCount
            }
            dependsOn {
              runId
            }
            driftDetection
            needsApproval
            runtimeConfig {
              projectRoot
              runnerImage
              terraform {
                version
                workflowTool
              }
              terragrunt {
                terraformVersion
                terragruntVersion
                tool
              }
            }
            forceApplyMode
            state
            title
            triggeredBy
            type
            branch
          }
          stack {
            id
            name
            blocker {
              id
            }
            canWrite
            labels
            lockedAt
            lockedBy
            namespace
            repository
            state
            spaceDetails {
              id
              accessLevel
            }
            vendorConfig {
              __typename
            }
          }
        }
      }
    }
  }
`;
